<template>
  <div>
    <section-collapseable
      :title="contactType.name + ' Details'"
      collapseable
      hide-initial-when-expanded
      :editable="!!customFields.length"
      @edit="$refs.contactTypeCustomFieldModal.open(contactContactType)"
    >
      <app-key-value-item
        v-for="field in visibleCustomFields"
        :key="field.id"
        :label="field.label"
        :value="field.value"
        :is-date="field.type === ENUMS.CustomFieldTypeEnum.Date.value"
        :is-currency="field.type === ENUMS.CustomFieldTypeEnum.Currency.value"
      ></app-key-value-item>

      <!-- Expanded Section -->
      <template v-slot:expanded>
        <app-empty-message
          :count="customFields.length"
          heading="There are no fields for this contact type, add some via settings."
          size="is-small"
        >
          <app-key-value-item
            v-for="field in customFields"
            :key="field.id"
            :label="field.label"
            :value="field.value"
            :is-date="field.type === ENUMS.CustomFieldTypeEnum.Date.value"
            :is-currency="field.type === ENUMS.CustomFieldTypeEnum.Currency.value"
          ></app-key-value-item>
        </app-empty-message>
      </template>
    </section-collapseable>

    <modal-container>
      <modal-crud-form
        ref="contactTypeCustomFieldModal"
        :title="contactType.name + ' Details'"
        form-component="contact-type-custom-fields-form"
        hide-delete-button
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";

export default {
  name: "ContactTypeFields",
  props: {
    contactContactType: {
      type: Object,
      required: true
    },
  },
  computed: {
    contactType() {
      return this.$store.getters.contactTypes.find(contactType => contactType.id === this.contactContactType.contact_type_id)
    },
    allCustomFields() {
      return this.$store.getters.customFields(ENUMS.CustomFieldableTypeEnum.ContactType.value, this.contactType.id);
    },
    contactContactTypeCustomFields() {
      return this.contactContactType.custom_fields;
    },
    customFields() {
      let customFields = this.allCustomFields.map(customField => {
        const contactField = this.contactContactTypeCustomFields.find(field => field.id === customField.id);

        return {
          id: customField.id,
          order: customField.order,
          value: (contactField) ? contactField.value : customField.default_value,
          type: customField.type,
          customFieldableType: customField.custom_fieldable_type,
          label: customField.label,
          options: customField.options,
          visible: customField.visible
        }
      });

      return customFields.sort((a, b) => a.order - b.order);
    },
    visibleCustomFields() {
      return this.customFields.filter(customField => customField.visible === true)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

</style>
